<button mat-mini-fab color="primary" [matTooltip]="toolTip" [matTooltipPosition]="toolTipPosition" [type]="buttonType" [attr.aria-label]="toolTip" [attr.aria-haspopup]="popup" [class]="cssClass" [disabled]="disabled">
	@if (materialIcon) {
		<mat-icon [ngClass]="{'small-icon': isIconSmall}">{{ materialIcon }}</mat-icon>
	}
	@if (fontelloIcon) {
		<i class="icon-{{fontelloIcon}}" [ngClass]="{'small-icon': isIconSmall}">{{ materialIcon }}</i>
	}
</button>
